import React from 'react';

interface CardProps {
  children: React.ReactNode;
  compact?: boolean;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  children,
  compact = false,
  className = '',
}) => {
  const baseStyles = 'bg-white dark:bg-slate-800 rounded-2xl border border-ds-border';
  const paddingStyles = compact ? 'p-5' : 'p-6';
  
  return (
    <div className={`${baseStyles} ${paddingStyles} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
